<template>
  <client-module
    :moduletitle="title"
    class="client-module"
  >
    <sky-dropdown-select
      v-if="customHint"
      slot="customHint"
      class="site-list"
      @change="changeSite"
      v-model="serviceId"
      :options="websiteList"
      :props="{ label: 'name', value: 'id' }"
    ></sky-dropdown-select>
    <div class="switch-content">
      <div class="time-switch">
        <skydropdown-select
          :options="group"
          @change="change"
          :value="selecttimetype"
        >
        </skydropdown-select>
        <!-- 日期选择器 -->
        <el-date-picker
          v-model="startDate"
          :type="pickerType"
          :firstDayOfWeek="1"
          :format="format"
          :disabled="disabled"
          clearable
          placeholder="请选择日期"
          :picker-options="pickerOptions"
          @change="dataChange"
        >
        </el-date-picker>
        <div
          class="time-date"
          v-if="startDate"
        >
          <span>{{ startDate }}</span>
          <span>至</span>
          <span>{{ endDate }}</span>
        </div>
      </div>
      <filter-panel
        :data="groups"
        :hideResult="true"
        @search="filterChange"
      ></filter-panel>
      <slot name="customFilter"></slot>
    </div>
  </client-module>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule'
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect'
import skydropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect'
import { getWeekTime, transferDate, GetMonthStr } from '@/utils/index.js'
import { getDateRegion } from '@/common/util.js'
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue'

export default {
  props: {
    title: {
      type: String,
    },
    selecttimetype: {
      type: String,
      default: 'WEEKLY',
    },
    customHint: {
      default: () => true,
    },
    websiteList: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    groups: {
      type: Object,
    },
    date: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'week',
    },
    dateFormat: {
      type: String,
      default: 'yyyy 第 WW 周',
    },
  },
  data() {
    let that = this
    return {
      group: [
        {
          label: '日报',
          value: 'DAILY',
        },
        {
          label: '周报',
          value: 'WEEKLY',
        },
        {
          label: '月报',
          value: 'MONTHLY',
        },
      ],
      startDate: that.date,
      endDate: that.date,
      pickerType: that.type,
      format: that.dateFormat,
      serviceId: '',
      pickerOptions: {
        disabledDate(time) {
          return that.dealDisabledDate(time)
        },
      },
    }
  },
  watch: {
    websiteList: {
      handler (val) {
        if (val.length == 0) { this.serviceId = ''; return false }
        this.serviceId = val[0].id
        let { selecttimetype } = this
        switch (selecttimetype) {
          case 'WEEKLY':
            this.getWeek()
            break
          case 'DAILY':
            this.getDetailDay()
            break
          case 'MONTHLY':
            this.getDetailMonth()
            break
        }
        this.change(selecttimetype)
      },
      deep: true,
    },
  },
  methods: {
    changeData(param) {
      let { startDate, endDate, serviceId, selecttimetype } = this
      this.$emit(
        'changeData',
        {
          startDate,
          endDate,
          serviceId,
          selecttimetype,
        },
        param
      )
    },
    // 网站切换
    changeSite(val) {
      let { selecttimetype } = this
      switch (selecttimetype) {
        case 'WEEKLY':
          this.getWeek()
          break
        case 'DAILY':
          this.getDetailDay()
          break
        case 'MONTHLY':
          this.getDetailMonth()
          break
      }
      this.serviceId = val
      this.changeData()
    },
    // 时间类型选择
    async change(val) {
      this.selecttime = ''
      await this.$emit('changeType', val)
      switch (val) {
        case 'WEEKLY':
          this.pickerType = 'week'
          this.format = 'yyyy 第 WW 周'
          this.dataPeriod = '前一周'

          if (this.WeeklyOlData) {
            this.dataChange(this.WeeklyOlData)
          } else {
            this.getWeek()
            this.changeData({ type: val })
          }
          break
        case 'DAILY':
          this.pickerType = 'date'
          this.format = 'yyyy-MM-dd'
          this.dataPeriod = '前一天'

          if (this.DailyOlData) {
            this.dataChange(this.DailyOlData)
          } else {
            this.getDetailDay()
            this.changeData({ type: val })
          }
          break
        case 'MONTHLY':
          this.pickerType = 'month'
          this.format = 'yyyy-MM'
          this.dataPeriod = '前一月'

          if (this.MonthlyOlData) {
            this.dataChange(this.MonthlyOlData)
          } else {
            this.getDetailMonth()
            this.changeData({ type: val })
          }
          break
        default:
          this.pickerType = 'week'
          break
      }
    },
    // 时间选择
    dataChange(val) {
      if (!val) {
        this.getWeek()
        this.changeData()
        return false
      }
      let { selecttimetype } = this
      // 周报
      if (selecttimetype === 'WEEKLY') {
        this.WeeklyOlData = val
        // 处理月份结束日期
        let weekEnd = val.getTime() + 6 * 24 * 3600 * 1000
        weekEnd = transferDate(new Date(weekEnd))
        let time = transferDate(val)

        this.startDate = time
        this.endDate = weekEnd
      }
      // 日报
      if (selecttimetype === 'DAILY') {
        this.DailyOlData = val
        let time = transferDate(val)

        this.startDate = time
        this.endDate = time
      }
      // 月报
      if (selecttimetype === 'MONTHLY') {
        this.MonthlyOlData = val
        let time = transferDate(val)
        // 求指定月长度
        let M = val.getMonth() + 1
        let Y = val.getFullYear()
        let lange = new Date(Y, M, 0).getDate()

        // 处理月份结束日期
        let arr = time.split('-')
        arr[2] = lange - 0

        this.startDate = time
        this.endDate = arr.join('-')
      }
      this.changeData()
    },
    // 时间选择器返回限制
    dealDisabledDate(time) {
      let { selecttimetype } = this
      if (selecttimetype === 'WEEKLY') {
        //按周日为一周的最后一天计算
        var week = new Date()
        //今天是这周的第几天
        var today = week.getDay() * 24 * 3600 * 1000

        // 三个月的开始结束时间
        // let date = GetMonthStr(3, 'day')
        // let end = new Date(date.last).getTime()
        return time.getTime() > Date.now() - today //|| time.getTime() < end
      }
      if (selecttimetype === 'DAILY') {
        // 三个月的开始结束时间
        let date = GetMonthStr(3, 'day')
        let start = new Date(date.now).getTime()
        // let end = new Date(date.last).getTime()
        return time.getTime() > start //|| time.getTime() < end
      }
      if (selecttimetype === 'MONTHLY') {
        // 三个月的开始结束时间
        // let date = GetMonthStr(3, 'day')
        // let end = new Date(date.last).getTime()
        return time.getTime() > Date.now() //|| time.getTime() < end
      }
    },
    // 获取时间初始值
    getWeek() {
      this.startDate = getWeekTime('start')
      this.endDate = getWeekTime('end')
    },
    // 日报初始化
    getDetailDay() {
      this.startDate = getDateRegion('DAY').split('至')[0]
      this.endDate = getDateRegion('DAY').split('至')[1]
    },
    // 月报初始化
    getDetailMonth() {
      this.startDate = getDateRegion('NEWMONTH').split('至')[0]
      this.endDate = getDateRegion('NEWMONTH').split('至')[1]
    },
    filterChange() {
      this.$emit('filterChange')
    },
  },
  components: {
    clientModule,
    skyDropdownSelect,
    skydropdownSelect,
    filterPanel,
  },
}
</script>

<style lang="scss" scoped>
.client-module {
  margin-bottom: 20px;
}
.site-list {
  margin-left: 20px;
}
.switch-content {
  display: flex;
}
.time-switch {
  width: 650px;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  .el-date-editor {
    margin-left: 52px;
    .el-range-separator {
      padding: 0;
    }
  }
  .time-date {
    color: #666;
    margin-left: 20px;
    font-size: 16px;
  }
  .el-dropdown {
    color: #5aa0ff;
  }
}
</style>
